import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { getProjectDetails, ProjectDetailsResponse } from 'services';

export type State = ApiState<ProjectDetailsResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchProjectDetails = createAsyncThunk('get/projectDetails', async () => await getProjectDetails());

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  //   data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const projectDetailsSlice = createSlice({
  name: 'projectDetails',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProjectDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchProjectDetails.fulfilled, (state, action: PayloadAction<ProjectDetailsResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchProjectDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { projectDetails: State }): State => state.projectDetails;

export const projectDetails_ = createSelector(stateSelector_, (state) => state.data);

export default projectDetailsSlice.reducer;
